import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./js/App";
import Routers from "./js/App";
import { BrowserRouter as Router } from "react-router-dom";
import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
registerServiceWorker();
